import { createContext, useContext } from 'react';

/**
 * Provides the favorites-page state to every component in the Sitecore layout tree.
 *
 * - `null`  = not on the favorites page; components behave normally
 * - `false` = favorites page, user has NO saved items → show MixedMediaGrid + ContentGrid, hide AdvancedContentGrid
 * - `true`  = favorites page, user HAS saved items  → show AdvancedContentGrid in favorites mode, hide the other two
 */
export const FavoritesPageContext = createContext<boolean | null>(null);

export const useFavoritesPage = () => useContext(FavoritesPageContext);
